import { h, render } from 'preact';
import FormComponent from './components/FormComponent.js';

document.addEventListener('DOMContentLoaded',  () => {
  const header = document.querySelector('.header-wrapper');
  const sectionColor = document.querySelector('.section-free-inquiry');
  if (sectionColor) header.style.backgroundColor = sectionColor.style.backgroundColor;

  const $el = document.getElementById('free-inquiry-form');
  const Form = () => {
    return (
      <FormComponent />
    );
  };

  if ($el) render(<Form/>, $el);
});

